import React from 'react'
import {  useSelector } from 'react-redux';
import { Link } from 'react-router-dom'
import {  RootState } from '../../store';


const Logo = ({ color }: { color: string }) => {
    const { siteInfo } = useSelector((state: RootState) => state.settingSlice);

    return (
        <Link to={"/"} className=' focus:outline-none'>
            <div className='w-full'>
                <img className='w-max ' src={`${color === "white" ? siteInfo?.whiteLogo : siteInfo?.darkLogo}`} alt="logo" />
            </div>
        </Link>
    )
}

export default Logo